<template>
  <div class ="hotMap">
    <myMap :fillCitys="fillCitys" :center="center" :Pzoom="13" :hotData="hotData" :g="g" :mapStyle="mapStyle" :max="1"></myMap>
  </div>
</template>

<script>
import myMap from '@/components/timeData/myMap.vue'
import { stringTime } from '@/common/js/commont.js'
import MixinWL from '@/store/wl/mixinsWl.js'
import { message } from 'ant-design-vue'

export default {
  mixins: [MixinWL],
  components: {
    myMap
  },
  data () {
    return {
      fillCitys: null,
      params: 'Noise',
      state: 0,
      sits: '',
      codes: '',
      hotData: [],
      center: {},
      Index: 0,
      pence: 0,
      hotArr: null,
      mapStyle: {
        styleJson: [
          {
            featureType: 'land',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'highway',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'river',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'railway',
            elementType: 'all',
            stylers: {
              color: '#5DA5BB'
            }
          },
          {
            featureType: 'sea',
            elementType: 'all',
            stylers: {
              color: '#eee'
            }
          }
        ]
      },
      g: {
        0.28:'rgba(82, 219, 117, 1)',
        0.43: 'rgba(252, 188, 5, 1)',
        0.57: 'rgba(255, 135, 25, 1)',
        0.71: 'rgba(223, 77, 77, 1)',
        0.85: 'rgba(114, 92, 218, 1)',
        1:'rgba(163, 60, 107, 1)'
      }
    }
  },
  created () {
    this. center = JSON.parse(window.localStorage.getItem('center'))
    this.getMapinfo()
  },
  methods: {
    st (value) {
      return stringTime(value)
    },
    // 获取点位和坐标
    getMapinfo () {
      var hide = message.loading('获取点位中,请稍后操作...', 0)
      var ts = stringTime(new Date())
      this.updateTime = ts
      var data = {
        token: window.localStorage.getItem('token'),
        account: window.localStorage.getItem('account'),
        ts
      }
      // 这段代码是为了将地图划分并配置数据
      this.getMapInfo(data).then(value => {
        this.sits = []
        this.codes = []
        // var towns = []
        value.list.forEach(item => {
          var li = {
            lng: parseFloat(item.lng),
            lat: parseFloat(item.lat),
            code: item.code,
            town: item.town,
            count: item['Noise']
          }
          this.sits.push(li)
          this.codes.push(item.code)
        })
        this.hotData = this.sits
        this.getHistoryData()
      }).catch(e => {
        this.$message.warning(e.message)
      }).finally(hide)
    },
    // 获取历史数据
    getHistoryData () {
      var ts = stringTime(new Date())
      var data = {
        account: window.localStorage.getItem('account'),
        codes: this.codes.join(','),
        datetype: 'H',
        max_time: stringTime(new Date()),
        min_time: stringTime(new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 3))),
        params: this.params,
        token: window.localStorage.getItem('token'),
        ts
      }
      this.getHistoryDeviceLog(data).then(value => {
        this.hotArr = value
        this.length = value[this.sits[0].code].length
        this.pence = 100 / this.length
        this.configHot(value)
      })
    },
    // 这段是为了将获取的历史数据分配到站点下
    configHot (value) {
      if (this.sits) {
        this.sits.forEach(sit => {
        // 如果有数据的话就设置数据没数据就为0
          if (value[sit.code]) {
            if (value[sit.code].length) {
              sit.count =value[sit.code][this.Index][this.params]
            } else {
              sit.count = 0
            }
          } else {
            sit.count = 0
          }
        })
        this.hotData = this.sits
      }
    }
  },
  watch: {
    Index (value) {
      this.$nextTick(() => {
        this.state = this.pence * value
        this.configHot(this.hotArr)
      })
    },
    state (value) {
      this.$nextTick(() => {
        this.Index = Math.round(value / this.pence)
      })
    }
  }
}
</script>

<style lang='less' scoped>
.hotMap {
  height: 100%;
  width: 100%;
}
</style>
